import {
  deleteChannel as destroyChannel,
  getDealChannels as retrieveDealChannels,
  saveChannel as persistChannel,
} from "api/channel";

export const PORTFOLIO_CHANNELS_GET = "PORTFOLIO_CHANNELS_GET";
export const DEAL_CHANNEL_CREATE = "DEAL_CHANNEL_CREATE";
export const DEAL_CHANNELS_GET = "DEAL_CHANNELS_GET";
export const DEAL_CHANNEL_SAVE = "DEAL_CHANNEL_SAVE";
export const DEAL_CHANNEL_DELETE = "DEAL_CHANNEL_DELETE";

export const getDealChannels = (dealID) => (dispatch) =>
  dispatch({
    type: DEAL_CHANNELS_GET,
    payload: retrieveDealChannels(dealID),
  });

export const createChannel = (dealID, channel) => (dispatch) =>
  dispatch({
    type: DEAL_CHANNEL_CREATE,
    payload: persistChannel(dealID, channel),
  });

export const saveChannel = (dealID, channel) => (dispatch) => {
  if (channel.id) {
    return dispatch({
      type: DEAL_CHANNEL_SAVE,
      payload: persistChannel(dealID, channel),
    });
  }

  return dispatch({
    type: DEAL_CHANNEL_CREATE,
    payload: persistChannel(dealID, channel),
  });
};

export const deleteChannel = (dealID, channelID) => (dispatch) =>
  dispatch({
    type: DEAL_CHANNEL_DELETE,
    meta: { channelID },
    payload: destroyChannel(dealID, channelID),
  });
